<template>
  <div class="view content">
    <div class="container content">
      <div class="main-title">Politique des cookies</div>
      <div class="internal-links">
        <a href="#question1">Qu'est-ce qu'un cookie ?</a>
        <a href="#question2">A quoi servent les cookies émis sur notre site ?</a>
        <a href="#question3">Quels types de cookies sont utilisés sur notre site ?</a>
        <a href="#question4">Quels cookies sont émis sur notre site par des tiers ?</a>
        <a href="#question5">Quelle est la durée de vie des cookies générés par notre site ?</a>
        <a href="#question6">Gestion de vos préférences sur les cookies et autres traceurs</a>
      </div>
      <div id="question1" class="title">Qu'est-ce qu'un cookie ?</div>
      <div class="paragraph">
        Un cookie est un fichier contenant des informations relatives à votre navigation et transmis à votre navigateur par le site internet que vous consultez.
        Ces informations contenues dans le cookie sont susceptibles d'être enregistrées sur votre terminal sous la forme d'un fichier texte auquel un serveur
        accède pour lire et enregistrer des informations. Les informations d'un fichier cookie permettent à leur émetteur d'identifier le terminal dans lequel
        il est enregistré, pendant sa durée de validité.
      </div>
      <div id="question2" class="title">A QUOI SERVENT LES COOKIES ÉMIS SUR NOTRE SITE ?</div>
      <div class="paragraph">Seul l'émetteur d'un cookie est susceptible de lire ou de modifier les informations qui y sont contenues.</div>
      <div class="paragraph">
        Les cookies utilisés sur notre site permettent d'identifier les services et rubriques que l'utilisateur a visités, et plus généralement son comportement
        en matière de visites. Ils mesurent le nombre de visites, le nombre de pages vues ainsi que son activité et sa fréquence de retour.
      </div>
      <div class="paragraph">
        Ces informations sont utiles pour faciliter votre navigation sur notre site et l'adapter à vos besoins. Des cookies sont également nécessaires au bon
        fonctionnement de certains services, notamment en matière de protocole de sécurisation de votre visite et de vos paiements.
      </div>
      <div id="question3" class="title">QUELS TYPES DE COOKIES SONT UTILISÉS SUR NOTRE SITE ?</div>
      <div class="paragraph">
        Lorsque vous vous connectez à notre site, nous pouvons être amenés, sous réserve de vos choix, à installer divers cookies dans votre terminal nous
        permettant de reconnaître le navigateur de votre terminal pendant la durée de validité du cookie concerné.
      </div>
      <div class="paragraph">
        Les cookies que nous émettons sont utilisés aux fins décrites ci-dessous, sous réserve de vos choix qui résultent des paramètres de votre logiciel de
        navigation utilisé lors de votre visite de notre site et de votre consentement considéré comme une manifestation de volonté, libre, spécifique et
        informée.
      </div>
      <div class="paragraph">Les cookies que nous émettons nous permettent de :</div>
      <ul>
        <li>
          • Faciliter votre navigation sur notre site :
          <ul>
            <li>
              en adaptant la présentation de notre site aux préférences d'affichage de votre terminal (langue utilisée, résolution d'affichage, système
              d'exploitation utilisé, etc.) lors de vos visites sur notre site, selon les matériels et les logiciels de visualisation ou de lecture que votre
              terminal comporte ;
            </li>
            <li>
              en mémorisant des informations relatives à un formulaire que vous avez rempli sur notre site (inscription ou accès à votre compte) ou à des
              produits, services ou informations que vous avez choisis sur notre site (service souscrit, contenu consulté, achat effectué etc …) ;
            </li>
            <li>
              en vous permettant d'accéder à des espaces réservés et personnels de notre site, tels que votre compte, grâce à des identifiants ou des données
              que vous nous avez éventuellement antérieurement confiés ;
            </li>
            <li>en mettant en œuvre des mesures de sécurité.</li>
          </ul>
        </li>
        <li>
          • Améliorer nos services :
          <ul>
            <li>
              en permettant d'établir des statistiques et volume de fréquentation et d'utilisation des divers éléments composant notre site (rubriques et
              contenus visité, parcours) afin d'améliorer l'intérêt et l'ergonomie de nos pages et de nos services.
            </li>
          </ul>
        </li>
      </ul>
      <div id="question4" class="title">QUELS COOKIES SONT ÉMIS SUR NOTRE SITE PAR DES TIERS ?</div>
      <div class="paragraph">
        Nous permettons à certains de nos partenaires d'émettre, et d'utiliser des cookies sur notre site internet destinés à améliorer l’interactivité de notre
        site. L'émission et l'utilisation de cookies par des tiers sont soumises aux politiques de protection de la vie privée qu'appliquent ces tiers et non à
        la présente charte.
      </div>
      <div class="paragraph">
        L'identité de chaque tiers ayant émis un/des cookies sur notre site est indiquée pour chacun des cookies dans la rubrique « GESTION DE VOS PREFERENCES
        SUR LES COOKIES ET AUTRES TRACEURS ».
      </div>
      <div class="paragraph">
        L'émission et l'utilisation de cookies par des tiers sont soumises aux politiques de protection de la vie privée qu'appliquent ces tiers. Nous vous
        informons de l'objet de ces cookies dont nous avons connaissance et des moyens dont vous disposez pour effectuer des choix à l'égard de ces cookies.
      </div>
      <div id="question5" class="title">QUELLE EST LA DURÉE DE VIE DES COOKIES GÉNÉRÉS PAR NOTRE SITE ?</div>
      <div class="paragraph">Les cookies générés sur notre site internet ont une durée de validité de 13 mois maximum.</div>
      <div id="question6" class="title">GESTION DE VOS PREFERENCES SUR LES COOKIES ET AUTRES TRACEURS</div>
      <div class="paragraph">
        Plusieurs possibilités vous sont offertes pour gérer les cookies. Tout paramétrage que vous pouvez entreprendre sera susceptible de modifier votre
        navigation sur Internet et notre site web ainsi que vos conditions d'accès à certains services nécessitant l'utilisation de cookies. Vous pouvez faire
        le choix à tout moment d'exprimer et de modifier vos souhaits en matière de cookies.
      </div>
      <div class="paragraph">
        Vous pouvez configurer votre logiciel de navigation de manière à ce que des cookies soient enregistrés dans votre terminal ou, au contraire, qu'ils
        soient rejetés, soit systématiquement, soit selon leur émetteur. Vous pouvez également configurer votre logiciel de navigation de manière à ce que
        l'acceptation ou le refus des cookies vous soient proposés ponctuellement, avant qu'un cookie soit susceptible d'être enregistré dans votre terminal.
      </div>
      <div class="paragraph">Enfin, vous pouvez ci-dessous activer ou désactiver les cookies émis par notre site.</div>
      <CookiesManagement class="table" :cookies-agreement="cookiesAgreement" @update-cookies-preference="updateCookiesPreference" />
      <button class="cookies-button main-button" :class="{ disabled: !cookiesUpdated }" @click="saveCookiesPreferences">
        {{ $t('cookies.saveCookiesPreferences') }}
      </button>
    </div>
  </div>
</template>

<script>
import CookiesManagement from '@/components/CookiesManagement.vue';

export default {
  components: { CookiesManagement },

  data() {
    return {
      cookiesAgreement: null,
      cookiesUpdated: false,
    };
  },

  created() {
    this.cookiesAgreement = !!localStorage.getItem('KYCCookies');
  },

  methods: {
    updateCookiesPreference(value) {
      this.cookiesAgreement = value;
      this.cookiesUpdated = true;
    },

    saveCookiesPreferences() {
      if (this.cookiesAgreement) {
        localStorage.setItem('KYCCookies', new Date());
        localStorage.removeItem('KYCCookiesRefused');
      } else {
        localStorage.setItem('KYCCookiesRefused', new Date());
        localStorage.removeItem('KYCCookies');
      }

      this.$nextTick(() => {
        this.$router.push({ name: 'Home' }, () => location.reload());
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
.view {
  display: flex;
  justify-content: center;
  padding-top: 90px;
}

.internal-links {
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  margin-bottom: 40px;
  border-bottom: 1px solid colors.$border-color;

  a {
    transition: 0.3s;
    margin: 10px 0;
    cursor: pointer;

    &:hover {
      color: colors.$accent-color;
    }
  }
}

.container {
  margin: 96px 0;
  max-width: 987px;

  .main-title {
    font-weight: 500;
    font-size: 28px;
    line-height: 30px;
    display: flex;
    align-items: center;
    color: colors.$darkblue-color;
    margin-bottom: 24px;
  }

  .title {
    font-weight: 500;
    font-size: 22px;
    line-height: 26px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    color: colors.$text-color;
    margin-bottom: 12px;
  }

  .paragraph {
    margin-bottom: 24px;
  }

  .link {
    color: colors.$main-color;
    text-decoration: underline;
    cursor: pointer;
    transition: 0.1s;

    &:hover {
      opacity: 0.8;
    }
  }
}

.cookies-button {
  margin-left: auto;
  width: max-content;
  padding: 0 20px;
  transition: 0.3s;
}
</style>
